// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    affiliateName: '',
    username: '',
    affiliateId: '',
};

const initialErrors = {
    affiliateName: '',
    username: '',
    affiliateId: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.selectedAffiliate) {
            setValues({
                id: props.setSelectedAffiliate.id,
                affiliateName: props.selectedAffiliate.affiliate_name,
                username: props.selectedAffiliate.username,
                affiliateId: props.selectedAffiliate.affiliate_id,
            });
        }
    }, [props.selectedAffiliate]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.put(
            `/api/affiliates/${props.selectedAffiliate.id}/`, {
                id: props.selectedAffiliate.id,
                affiliate_name: values.affiliateName,
                username: values.username,
                affiliate_id: values.affiliateId,
            },
            abortController
        ).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.affiliateName = (data.affiliate_name) ? data.affiliate_name[0] : '';
                _errors.username = (data.username) ? data.username[0] : '';
                _errors.affiliateId = (data.affiliate_id) ? data.affiliate_id[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedAffiliate(null);
    };

    return (
        <DialogForm title='Изменение партнера' label='Изменить'
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Название партнера"
                       value={values.affiliateName} onChange={handleChange('affiliateName')}
                       error={errors.affiliateName.length > 0}
                       helperText={errors.affiliateName}
                       onFocus={handleFocus('affiliateName')}
                       autoFocus={true}
            />
            <TextField label="Имя пользователя" type="email"
                       value={values.username} onChange={handleChange('username')}
                       error={errors.username.length > 0}
                       helperText={errors.username}
                       onFocus={handleFocus('username')}
            />
            <TextField label="ID партнера" type="number" inputProps={{min: 1}}
                       value={values.affiliateId} onChange={handleChange('affiliateId')}
                       error={errors.affiliateId.length > 0}
                       helperText={errors.affiliateId}
                       onFocus={handleFocus('affiliateId')}
            />
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedAffiliate: PropTypes.object,
    setSelectedAffiliate: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
